import { formattedCurrentMonthData } from "./currentMonthData";
import { formattedFutureMonthData } from "./futureMonthData";
const currencyFormat = (num) => {
  if (num)
    return num
      ?.toFixed(0)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, "") // remove any existing international commas
      .replace(/\d+/, (m) => {
        const lastThree = m.slice(-3);
        const rest = m.slice(0, -3);
        return (
          rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
          (rest ? "," : "") +
          lastThree
        );
      });
  // return num
  //   ?.toFixed(0)
  //   .toString()
  //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  //   .replace(/\d+/, (m) => m.replace(/(\d)(?=(\d{2})+(?!\d))/g, "$1,"));
  //   //.replace(/(\d+)(?=(\d{2})+(?=(\d{3})(?!\d)))/g, "$1,");
  else return 0;
};

const getCurrentMonthDatesAsia = () => {
  const timeZone = "Asia/Kolkata";

  // Function to format date as yyyy-mm-dd in a specific time zone
  const formatDate = (date, timeZone, returnDayOnly = false) => {
    const options = {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const formattedDateParts = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(date);
    const year = formattedDateParts.find((part) => part.type === "year").value;
    const month = formattedDateParts.find(
      (part) => part.type === "month"
    ).value;
    const day = formattedDateParts.find((part) => part.type === "day").value;

    return returnDayOnly ? day : `${year}-${month}-${day}`;
  };

  // Create a Date object adjusted to the time zone
  const now = new Date();
  const currentDateInTimeZone = new Date(
    now.toLocaleString("en-US", { timeZone })
  );

  // Start of the month in the specified time zone
  const startOfMonthInTimeZone = new Date(
    currentDateInTimeZone.getFullYear(),
    currentDateInTimeZone.getMonth(),
    1
  );

  // End of the month in the specified time zone
  const endOfMonthInTimeZone = new Date(
    currentDateInTimeZone.getFullYear(),
    currentDateInTimeZone.getMonth() + 1,
    0
  );

  // Total number of days in the current month
  const daysInMonth = endOfMonthInTimeZone.getDate();

  // Today + 2 days in the specified time zone
  const todayPlusTwoInTimeZone = new Date(currentDateInTimeZone);
  todayPlusTwoInTimeZone.setDate(currentDateInTimeZone.getDate() + 2);

  // Format the dates
  return {
    startOfMonth: formatDate(startOfMonthInTimeZone, timeZone),
    currentDate: formatDate(currentDateInTimeZone, timeZone),
    endOfMonth: formatDate(endOfMonthInTimeZone, timeZone),
    daysInMonth: daysInMonth,
    todayPlusTwoDay: formatDate(todayPlusTwoInTimeZone, timeZone, true), // Return only the day
  };
};
const getFutureMonthDatesAsia = () => {
  const timeZone = "Asia/Kolkata";

  // Function to format date as yyyy-mm-dd in a specific time zone
  const formatDate = (date, timeZone, returnDayOnly = false) => {
    const options = {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const formattedDateParts = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(date);
    const year = formattedDateParts.find((part) => part.type === "year").value;
    const month = formattedDateParts.find(
      (part) => part.type === "month"
    ).value;
    const day = formattedDateParts.find((part) => part.type === "day").value;

    return returnDayOnly ? day : `${year}-${month}-${day}`;
  };

  // Create a Date object adjusted to the time zone
  const now = new Date();
  const currentDateInTimeZone = new Date(
    now.toLocaleString("en-US", { timeZone })
  );

  // Start of the month in the specified time zone
  const startOfMonthInTimeZone = new Date(
    currentDateInTimeZone.getFullYear(),
    currentDateInTimeZone.getMonth() + 1,
    1
  );

  // End of the month in the specified time zone
  const endOfMonthInTimeZone = new Date(
    currentDateInTimeZone.getFullYear(),
    currentDateInTimeZone.getMonth() + 2,
    0
  );

  // Total number of days in the current month
  const daysInMonth = endOfMonthInTimeZone.getDate();

  // Today + 2 days in the specified time zone
  const todayPlusTwoInTimeZone = new Date(currentDateInTimeZone);
  todayPlusTwoInTimeZone.setDate(currentDateInTimeZone.getDate() + 2);

  // Format the dates
  return {
    startOfMonth: formatDate(startOfMonthInTimeZone, timeZone),
    currentDate: formatDate(startOfMonthInTimeZone, timeZone),
    endOfMonth: formatDate(endOfMonthInTimeZone, timeZone),
    daysInMonth: daysInMonth,
    todayPlusTwoDay: formatDate(todayPlusTwoInTimeZone, timeZone, true), // Return only the day
  };
};

const daysInCurrentMonth = () => {
  var today = new Date();
  return new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
};

const formatDate = (date) => {
  const timeZone = "Asia/Kolkata";
  const options = { timeZone };
  const year = date.toLocaleDateString("en-US", {
    ...options,
    year: "numeric",
  });
  const month = date.toLocaleDateString("en-US", {
    ...options,
    month: "2-digit",
  });
  const day = date.toLocaleDateString("en-US", { ...options, day: "2-digit" });
  return `${year}-${month}-${day}`;
};
const now = new Date();

const startOfMonth = () =>
  formatDate(new Date(now.getFullYear(), now.getMonth(), 1));

const currentDate = () => formatDate(now);

const endOfMonth = () =>
  formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0));

const startOfFutureMonth = () =>
  formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 1));

const endOfFutureMonth = () =>
  formatDate(new Date(now.getFullYear(), now.getMonth() + 2, 0));

const getDatesFromMonthYearAsia = (date) => {
  const timeZone = "Asia/Kolkata";

  // Function to format date as yyyy-mm-dd in a specific time zone
  const formatDate = (date, timeZone, returnDayOnly = false) => {
    const options = {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const formattedDateParts = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(date);
    const year = formattedDateParts.find((part) => part.type === "year").value;
    const month = formattedDateParts.find(
      (part) => part.type === "month"
    ).value;
    const day = formattedDateParts.find((part) => part.type === "day").value;

    return returnDayOnly ? day : `${year}-${month}-${day}`;
  };

  // Create a Date object adjusted to the time zone
  const now = new Date(date);
  const currentDateInTimeZone = new Date(
    now.toLocaleString("en-US", { timeZone })
  );

  // Start of the month in the specified time zone
  const startOfMonthInTimeZone = new Date(
    currentDateInTimeZone.getFullYear(),
    currentDateInTimeZone.getMonth(),
    1
  );

  // End of the month in the specified time zone
  const endOfMonthInTimeZone = new Date(
    currentDateInTimeZone.getFullYear(),
    currentDateInTimeZone.getMonth() + 1,
    0
  );

  // Total number of days in the current month
  const daysInMonth = endOfMonthInTimeZone.getDate();

  // Today + 2 days in the specified time zone
  const todayPlusTwoInTimeZone = new Date(currentDateInTimeZone);
  todayPlusTwoInTimeZone.setDate(currentDateInTimeZone.getDate() + 2);

  // Format the dates
  return {
    startOfMonth: formatDate(startOfMonthInTimeZone, timeZone),
    currentDate: formatDate(new Date(), timeZone),
    endOfMonth: formatDate(endOfMonthInTimeZone, timeZone),
    daysInMonth: daysInMonth,
    todayPlusTwoDay: formatDate(todayPlusTwoInTimeZone, timeZone, true), // Return only the day
  };
};

const getUser = () => {
  return localStorage.getItem("user");
};
const checkIsAdmin = () => {
  return localStorage.getItem("isAdmin");
};

const cellStyle = (params) => {
  let value = 0;
  //console.log(params)
  // Handle both leaf and aggregated rows
  if (params.value?.golmValue !== undefined) {
    value = params.value.golmValue;
  } else if (typeof params.value === "number") {
    value = params.value;
  }

  if (value <=0 || Number.isNaN(value) || value==Infinity) {
    return { backgroundColor: "#EFB5B9", textAlign: "center" }; // red
  } else if (value >=0.1 && value <=5) {
    return { backgroundColor: "#F0E199", textAlign: "center" }; // yellow
   } 
  else{
    return { backgroundColor: "#7BF6BB", textAlign: "center" }; // green
  }
};

export {
  currencyFormat,
  getCurrentMonthDatesAsia,
  daysInCurrentMonth,
  formattedCurrentMonthData,
  startOfMonth,
  currentDate,
  endOfMonth,
  getFutureMonthDatesAsia,
  formattedFutureMonthData,
  startOfFutureMonth,
  endOfFutureMonth,
  getDatesFromMonthYearAsia,
  getUser,
  checkIsAdmin,
  cellStyle,
};
